import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StateEnrollmentParams } from "../types/enrollment/enrollment";

interface EnrollmentUsersInitialStateParams {
    isLoading: boolean;
    getAllEnrollmentUsers: StateEnrollmentParams[];
    searchEnrollmentUser: StateEnrollmentParams[];
    currentPage: number;
    numberOfPages: number;
    totalNumber: number;
    singleEnrollmentUser: StateEnrollmentParams | null;
    updateEnrollmentUser: StateEnrollmentParams[] | null;
    deleteEnrollmentUser: StateEnrollmentParams[] | null;
}

const initialState: EnrollmentUsersInitialStateParams = {
    isLoading: true,
    getAllEnrollmentUsers: [],
    searchEnrollmentUser: [],
    currentPage: 1,
    numberOfPages: 0,
    totalNumber: 0,
    singleEnrollmentUser: null,
    updateEnrollmentUser: null,
    deleteEnrollmentUser: null,
}

const enrollmentUsersSlice = createSlice({
    name: 'ENROLLMENT',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setEnrollmentUsers: (state, action: PayloadAction<{
            data: StateEnrollmentParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.getAllEnrollmentUsers   = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
        setSingleEnrollmentUser: (state, action: PayloadAction<StateEnrollmentParams>) => {
            state.singleEnrollmentUser          = action.payload;
        },
        setEnrollmentUsersSearch: (state, action: PayloadAction<{
            data: StateEnrollmentParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.searchEnrollmentUser    = action.payload.data;
            state.currentPage         = action.payload.currentPage
            state.numberOfPages       = action.payload.numberOfPages
            state.totalNumber         = action.payload.totalNumber
        },
        setUpdateEnrollmentUser: (state, action: PayloadAction<StateEnrollmentParams>) => {
            state.updateEnrollmentUser          = state.getAllEnrollmentUsers.map((result) =>
                result._id === action.payload._id ? action.payload : result
            );
        },
        setDeleteEnrollmentUser: (state, action: PayloadAction<string>) => {
            state.deleteEnrollmentUser = state.getAllEnrollmentUsers.filter((result) => result._id !== action.payload);
        }
    }
});

export const { startLoading, endLoading, setEnrollmentUsers, setSingleEnrollmentUser, setEnrollmentUsersSearch, setUpdateEnrollmentUser, setDeleteEnrollmentUser } = enrollmentUsersSlice.actions
export default enrollmentUsersSlice.reducer
